import config from "@/config"
import http from "@/utils/request"
export default {
    imageList: {
        url: `${config.API_URL}/deviceImage/`,
        name: "查看设备图片列表",
        get: async function (id, data) {
            return await http.get(this.url + id + "/", data);
        },
    },
    addImage: {
        url: `${config.API_URL}/deviceImage/`,
        name: "添加设备图片",
        post: async function (id, data) {
            return await http.post(this.url + id + "/", data);
        },
    },
    deleteImage: {
        url: `${config.API_URL}/deviceImage/`,
        name: "删除设备图片",
        delete: async function (id, data) {
            return await http.delete(this.url + id + "/", data);
        },
    },
    attrList: {
        url: `${config.API_URL}/deviceAttributeList/`,
        name: "设备属性统计列表",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    attrLatest: {
        url: `${config.API_URL}/deviceAttributeLatest/`,
        name: "设备属性最新数据",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    uploadAlarm: {
        url: `${config.API_URL}/deviceUploadAlarm/`,
        name: "获取设备上报的报警数据",
        get: async function (id, data) {
            return await http.get(this.url + id + "/", data);
        },
    },
    uploadFault: {
        url: `${config.API_URL}/deviceUploadFault/`,
        name: "获取设备上报的故障数据",
        get: async function (id, data) {
            return await http.get(this.url + id + "/", data);
        },
    },
    uploadHeart: {
        url: `${config.API_URL}/deviceUploadHeartbeat/`,
        name: "获取设备上报的心跳数据",
        get: async function (id, data) {
            return await http.get(this.url + id + "/", data);
        },
    },
    upInstruct: {
        url: `${config.API_URL}/command/`,
        name: "获取指令下发记录",
        get: async function (id, data) {
            return await http.get(this.url + id + "/", data);
        },
    },
    bindUser: {
        url: `${config.API_URL}/bindDevicePersonnel/`,
        name: "绑定权利",
        get: async function (id, data) {
            return await http.get(this.url + id + "/", data);
        },
    },
    updateEmpower: {
        url: `${config.API_URL}/updateEmpower/`,
        name: "修改用户执行权限",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    somkeDetector: {
        url: `${config.API_URL}/device/`,
        name: "433烟感",
        get: async function (id, data) {
            return await http.get(this.url + id + "/", data);
        },
    },
    somkeChiledDevice: {
        url: `${config.API_URL}/query433IbmChildDevice/`,
        name: "433烟感主机下面的烟感设备",
        get: async function (id, data) {
            return await http.get(this.url + id + "/", data);
        },
    },
    smokerChilerAddr: {
        url: `${config.API_URL}/upload433IbmChildDeviceAddress/`,
        name: "修改用户执行权限",
        post: async function (id, data) {
            return await http.post(this.url + id + "/", data);
        },
    },
    downholeGasDetectors: {
        url: `${config.API_URL}/downholeGasDetectors/`,
        name: '查询"地下空间及井下燃气探测器"其它数据',
        get: async function (id) {
            return await http.get(this.url + id);
        },
    },
    getIndustrialGasClassify: {
        url: `${config.API_URL}/query4GIndustrialGas/classify/`,
        name: '查询"地下空间及井下燃气探测器"其它数据',
        get: async function (id) {
            return await http.get(this.url + id);
        },
    },
    setGatherUpload: {
        url: `${config.API_GAS}/order/setGatherUpload`,
        name: "地下空间及井下燃气探测器下发功能",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    queryIA4GRC: {
        url: `${config.API_URL}/industryAas4gRelevanceCamera/`,
        name: "查询4g工业燃气关联摄像头",
        get: async function (id) {
            return await http.get(this.url + id);
        },
    },
    relevanceCamera: {
        url: `${config.API_URL}/industryAas4gRelevanceCamera/add/`,
        name: "4g工业燃气关联摄像头",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        },
    },
    deleterelevanceCamera: {
        url: `${config.API_URL}/industryAas4gRelevanceCamera/del/`,
        name: "取消关联摄像头",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        },
    },

    setWarnValue: {
        url: `${config.API_GAS}/order/setWarnValue`,
        name: "下发高报低报阈值指令(生产)",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    getTrendDataAPI: {
        url: `${config.API_URL}/concentrationTrend20241007/`,
        name: "获取4g工业燃气浓度趋势数据",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    get4gTrendAPI: {
        url: `${config.API_URL}/4g_AGSH-DX/deviceTrendData/`,
        name: '获取"地下空间及井下燃气探测器(4g_AGSH-DX)"设备数据趋势数据',
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    setSensitivity: {
        url: `${config.API_GAS}/order/setVibrateSensitivity`,
        name: "下发探测器的震动传感器灵敏度",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    setMobileSensitivity: {
        url: `${config.API_GAS}/order/mobileSensitivityThreshold`,
        name: "下发探测器的移动传感器灵敏度",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },

    querySleepRadar: {
        url: `${config.API_URL}/R60ABD1/query/`,
        name: "查询睡眠雷达数据信息",
        get: async function (id) {
            return await http.get(this.url + id);
        },
    },
    querySleepSynthesisState: {
        url: `${config.API_URL}/R60ABD1/query/sleepQualityAnalysis/`,
        name: "根据设备id查询睡眠综合状态数据",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    sleepQualityAnalysis: {
        url: `${config.API_URL}/R60ABD1/query/sleepSynthesisState/`,
        name: "根据设备id查询睡眠质量分析数据",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    humanExistence: {
        url: `https://iot.tranthing.com/sleep_radar/issued/humanExistenceSwitch/`,
        // url: `http://192.168.3.10:8006/issued/humanExistenceSwitch/`,
        name: "开关人体存在",
        post: async function (deviceNum, data) {
            return await http.post(this.url + deviceNum + "/", data);
        },
    },
    heartRateMonitoring: {
        url: `https://iot.tranthing.com/sleep_radar/issued/heartRateMonitoringSwitch/`,
        // url: `http://192.168.3.10:8006/issued/heartRateMonitoringSwitch/`,
        name: "开关心率监测功能",
        post: async function (deviceNum, data) {
            return await http.post(this.url + deviceNum + "/", data);
        },
    },
    respiratoryMonitoring: {
        url: `https://iot.tranthing.com/sleep_radar/issued/respiratoryMonitoringSwitch/`,
        // url: `http://192.168.3.10:8006/issued/respiratoryMonitoringSwitch/`,
        name: "开关呼吸监测功能",
        post: async function (deviceNum, data) {
            return await http.post(this.url + deviceNum + "/", data);
        },
    },
    sleepMonitoring: {
        url: `https://iot.tranthing.com/sleep_radar/issued/sleepMonitoringSwitch/`,
        // url: `http://192.168.3.10:8006/issued/sleepMonitoringSwitch/`,
        name: "开关睡眠监测功能",
        post: async function (deviceNum, data) {
            return await http.post(this.url + deviceNum + "/", data);
        },
    },
    reportingMode: {
        url: `https://iot.tranthing.com/sleep_radar/issued/reportingMode/`,
        // url: `http://192.168.3.10:8006/issued/reportingMode/`,
        name: "上报模式选择",
        post: async function (deviceNum, data) {
            return await http.post(this.url + deviceNum + "/", data);
        },
    },

    strugglingState: {
        url: `https://iot.tranthing.com/sleep_radar/issued/strugglingStateSwitch/`,
        // url: `http://192.168.3.10:8006/issued/strugglingStateSwitch/`,
        name: "异常挣扎状态功能",
        post: async function (deviceNum, data) {
            return await http.post(this.url + deviceNum + "/", data);
        },
    },

    regionalScope: {
        url: `${config.API_URL}/R60ABD1/query/beyondRegionalScope/`,
        name: "位置越界",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },

    presenceState: {
        url: `${config.API_URL}/R60ABD1/query/humanBodyPresenceState/`,
        name: "人体存在",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },

    heartRate: {
        url: `${config.API_URL}/R60ABD1/query/heartRate/`,
        name: "心率数值",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    humanMoveState: {
        url: `${config.API_URL}/R60ABD1/query/humanBodyMoveState/`,
        name: "人体运动",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    breatheState: {
        url: `${config.API_URL}/R60ABD1/query/breatheState/`,
        name: "呼吸状态",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    breatheValue: {
        url: `${config.API_URL}/R60ABD1/query/breatheValue/`,
        name: "呼吸数值",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    inBedState: {
        url: `${config.API_URL}/R60ABD1/query/inBedState/`,
        name: "入床/离床状态",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    sleepState: {
        url: `${config.API_URL}/R60ABD1/query/sleepState/`,
        name: "睡眠状态",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    lucidDuration: {
        url: `${config.API_URL}/R60ABD1/query/lucidDuration/`,
        name: "清醒时长",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    catnapDuration: {
        url: `${config.API_URL}/R60ABD1/query/catnapDuration/`,
        name: "浅睡时长",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    deepSleepDuration: {
        url: `${config.API_URL}/R60ABD1/query/deepSleepDuration/`,
        name: "深睡时长",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    sleepDisorders: {
        url: `${config.API_URL}/R60ABD1/query/sleepDisorders/`,
        name: "睡眠异常",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    abnormalFlounderState: {
        url: `${config.API_URL}/R60ABD1/query/abnormalFlounderState/`,
        name: "异常挣扎状态",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },
    sleepQualityRating: {
        url: `${config.API_URL}/R60ABD1/query/sleepQualityRating/`,
        name: "睡眠质量评级",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        },
    },

    fallRadarDetail: {
        url: `${config.API_URL}/fd101/`,
        name: "查询跌倒雷达详情",
        get: async function (id) {
            return await http.get(this.url + id);
        },
    },

    fallSetSite: {
        url: `${config.FD1014G_URL}/setSite`,
        name: "场景设置",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    fallSetHeight: {
        url: `${config.FD1014G_URL}/setHeight`,
        name: "安装高度",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    fallObjectExist: {
        url: `${config.FD1014G_URL}/openObjectExist`,
        // url: "https://apifoxmock.com/m1/4967092-0-default/openObjectExist?state=0",
        name: "开关人体存在功能",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    fallMonitor: {
        url: `${config.FD1014G_URL}/openFallMonitor`,
        name: "开关跌倒监测功能",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    fallStayTime: {
        url: `${config.FD1014G_URL}/setResidenceTime`,
        name: "驻留时长设置",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    fallOpenStop: {
        url: `${config.FD1014G_URL}/openStop`,
        name: "驻留开关设置",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    fallTime: {
        url: `${config.FD1014G_URL}/fallTime`,
        name: "跌倒时长设置",
        get: async function (data) {
            return await http.get(this.url, data);
        },
    },
    fallSensitivity: {
        url: `${config.FD1014G_URL}/setFallingSensitivity`,
        // url: `https://apifoxmock.com/m1/4967092-0-default/setFallingSensitivity?state=1`,
        name: "跌倒灵敏度设置",
        post: async function (data) {
            return await http.post(this.url, data, "application/json");
        },
    },

    gateway433Jkd: {
        url: `${config.API_URL}/433GatewayJkd/`,
        name: "",
        get: async function (id) {
            return await http.get(this.url + id);
        },
    },

    deleteRegional: {
        url: `${config.API_URL}/433GatewayJkd/deleteRegional/`,
        name: "删除防区",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        },
    },

    regionalSelfTest: {
        url: `${config.API_URL}/433GatewayJkd/regionalSelfTest/`,
        name: "下发防区自检",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        },
    },

    regionalMuteReq: {
        url: `${config.API_URL}/433GatewayJkd/regionalMuteReq/`,
        name: "下发防区消音",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        },
    },

    remotePhotography: {
        url: `${config.API_GAS}/order/remotePhotography`,
        name: "下发远程拍照",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },


    cameraTimer: {
        url: `${config.API_GAS}/order/cameraTimer`,
        name: "下发定时时间拍照",
        post: async function (data) {
            return await http.post(this.url, data, "application/json");
        },
    },
    
    // 远程升级摄像头
    upCamera: {
        url: `${config.API_GAS}/order/upgradeCamera`,
        name: "远程升级摄像头",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    batchUpCamera: {
        url: `${config.API_GAS}/order/batch/upgradeCamera`,
        name: "批量下发远程升级摄像头",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    // 
    init_Gas: {
        url: `${config.API_URL}/init/industrialGas`,
        name: "批量初始化工业燃气",
        post: async function (data) {
            return await http.post(this.url, data);
        },
    },
    queryRssi: {
        url: `${config.API_URL}/query/AGSHDXCameraAttribute/`,
        name: "查询 地下空间及井下燃气探测器 的所有摄像头属性数据",
        get: async function (deviceId) {
            return await http.get(this.url + deviceId);
        },
    },
    cameraBuriedUnderground: {
        url: `${config.API_URL}/device/camera_buried_underground/`,
        name: "查询地埋桩摄像头信息",
        get: async function (deviceId) {
            return await http.get(this.url + deviceId + "/");
        },
    },
    queryCameraDetail: {
        url: `${config.API_URL}/qxCamera/device/cameraDetails`,
        name: "根据国标ID(设备编号)查询摄像头详情数据",
        get: async function (deviceNum) {
            return await http.get(this.url, deviceNum);
        },
    },
    setTump: {
        url: `${config.API_URL}/humitureAlarm/order/temperature/`,
        name: "设置温度",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        },
    },
    setHum: {
        url: `${config.API_URL}/humitureAlarm/order/humidity/`,
        name: "设置湿度",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        },
    },
    setHeart: {
        url: `${config.API_URL}/humitureAlarm/order/heartbeatTime/`,
        name: "设置心跳时间",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        },
    },
    
    coorRecord: {
        url: `${config.API_URL}/query/coordinate/`,
        name: "查询坐标记录",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        }
    },

    fenceDataAPI: {
        url: `${config.API_URL}/query/overRangeAlarm/`,
        name: "获取电子围栏数据",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },
    setFenceAPI: {
        url: `${config.API_URL}/set/overRangeAlarm`,
        name: "设置电子围栏数据",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    overRangeAlarmSwitch:{
        url: `${config.API_URL}/set/overRangeAlarmSwitch`,
        name: "设置4g工业燃气设备超出范围报警开关",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    oneClickAlarm: {
        url: `${config.API_URL}/XHW1/queryXHW1BasicData/`,
        name: "一键报警",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },
    
    setMute: {
        url: `${config.API_URL}/XHW1/SetSoundSize/`,
        name: "设置声音大小",
        post: async function (id, val) {
            return await http.post(this.url + id, { size : val});
        }
    },

    setSound: {
        url: `${config.API_URL}/XHW1/setSilentMode/`,
        name: "设置静音模式",
        post: async function (id, val) {
            return await http.post(this.url + id, { state: val });
        }
    },

    setPosit: {
        url: `${config.API_URL}/XHW1/setPositioningPriority/`,
        name: "设置定位优先级",
        post: async function (id, val) {
            return await http.post(this.url + id, { priority: val });
        }
    },

    setGnss: {
        url: `${config.API_URL}/XHW1/setGnssSwitch/`,
        name: "设置GNSS开关",
        post: async function (id, val) {
            return await http.post(this.url + id, { locationMode: val });
        }
    },

    default: {
        url: `${config.API_URL}/XHW1/restoreFactorySettings/`,
        name: "恢复出厂设置",
        post: async function (id) {
            return await http.post(this.url + id);
        }
    },

    upOTA: {
        url: `${config.API_URL}/XHW1/upgradeOTA/`,
        name: "OTA升级",
        post: async function (id) {
            return await http.post(this.url + id);
        }
    },

    playBell: {
        url: `${config.API_URL}/XHW1/playRingtone/`,
        name: "播放铃声",
        post: async function (id) {
            return await http.post(this.url + id);
        }
    },

    sosPhone: {
        url: `${config.API_URL}/XHW1/queryXHW1PhoneData/`,
        name: "查询一键报警(SOS)号码",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },
    callLog: {
        url: `${config.API_URL}/XHW1/queryXhW1CallLog/`,
        name: "查询SOS通话记录",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },
    locationLog: {
        url: `${config.API_URL}/XHW1/queryXhW1LocateLog/`,
        name: "查询定位坐标记录",
        get: async function (id, data) {
            return await http.get(this.url + id, data);
        }
    },

    setPhone: {
        url: `${config.API_URL}/XHW1/setPhoneNumber/`,
        name: "下发设置号码",
        post: async function (id, data) {
            return await http.post(this.url + id, data);
        }
    },

    setIP: {
        url: `${config.API_GAS}/order/issueIPBinding`,
        name: "下发IP/域名地址,端口",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    batchSetIP: {
        url: `${config.API_GAS}/order/batch/issueIPBinding`,
        name: "下发IP/域名地址,端口",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    //查询hx100abw设备属性数据
    getHX100abwData:{
        url: `${config.API_URL}/HX100ABW/query/attribute/`,
        name: "查询hx100abw设备属性数据",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },

    // 查询hx100abw上报数据日志
    getHX100abwRunLog:{
        url: `${config.API_URL}/HX100ABW/query/runLog/`,
        name: "查询hx100abw上报数据日志",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },

    // 查询天一达详情数据
    getTianYiDaData:{
        url: `${config.API_URL}/tianYiDa/query/details/`,
        name: "查询天一达详情数据",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },
    // 查询天一达报警状态
    getTianYiDaAlarmStatus:{
        url: `${config.API_URL}/tianYiDa/query/alarmStatus/`,
        name: "查询天一达报警状态",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },

    // 查询天一达回路数据
    getTianYiDaLoopData:{
        url: `${config.API_URL}/tianYiDa/query/loopData/`,
        name: "查询天一达回路数据",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },

    // 查询 WYA1-4TL 额外数据
    getWYA1Data:{
        url: `${config.API_URL}/electric_fire/query/`,
        name: "查询WYA1-4TL额外数据",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },
    // 查询 WYA1-4TL 设备属性
    getWYA1Attributes:{
        url: `${config.API_URL}/electric_fire/query/attributes/`,
        name: "查询WYA1-4TL设备属性",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },
    // 查询 WYA1-4TL 计划时间开机关机
    getWYA1ScheduledTime:{
        url: `${config.API_URL}/electric_fire/query/scheduledTime/`,
        name: "查询WYA1-4TL计划时间开机关机",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },
    // 查询 WYA1-4TL 功率计划
    getWYA1PowerPlan:{
        url: `${config.API_URL}/electric_fire/query/powerPlan/`,
        name: "查询WYA1-4TL功率计划",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },
    // WYA1-4TL 设备复位
    wya1DeviceReset:{
        url: `${config.API_WYA1_COMMAND}/order/9001`,
        name: "WYA1-4TL设备复位",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 设备消音
    wya1DeviceMute:{
        url: `${config.API_WYA1_COMMAND}/order/9002`,
        name: "WYA1-4TL设备消音",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 设备自检
    wya1DeviceSelfCheck:{
        url: `${config.API_WYA1_COMMAND}/order/9003`,
        name: "WYA1-4TL设备自检",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 设备断电
    wya1DevicePowerOff:{
        url: `${config.API_WYA1_COMMAND}/order/9004`,
        name: "WYA1-4TL设备断电",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 设备合闸
    wya1DeviceCloseSwitch:{
        url: `${config.API_WYA1_COMMAND}/order/9005`,
        name: "WYA1-4TL设备合闸",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 取消计划开关机
    wya1CancelScheduledSwitch:{
        url: `${config.API_WYA1_COMMAND}/order/900A`,
        name: "WYA1-4TL取消计划开关机",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 取消功率计划
    wya1CancelPowerPlan:{
        url: `${config.API_WYA1_COMMAND}/order/900C`,
        name: "WYA1-4TL取消功率计划",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 读取报警设置的阈值
    wya1ReadAlarmThreshold:{
        url: `${config.API_WYA1_COMMAND}/order/9007`,
        name: "WYA1-4TL读取报警设置的阈值",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 远程设置报警阈值
    wya1SetAlarmThreshold:{
        url: `${config.API_WYA1_COMMAND}/order/9006`,
        name: "WYA1-4TL远程设置报警阈值",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 设置远程服务器IP和端口
    wya1SetServerIpPort:{
        url: `${config.API_WYA1_COMMAND}/order/9008`,
        name: "WYA1-4TL设置远程服务器IP和端口",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 设置计划时间开机关机
    wya1SetScheduledSwitch:{
        url: `${config.API_WYA1_COMMAND}/order/9009`,
        name: "WYA1-4TL设置计划时间开机关机",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 设置报警时间和短路电流倍数
    wya1SetAlarmTimeAndCurrentMultiple:{
        url: `${config.API_WYA1_COMMAND}/order/900D`,
        name: "WYA1-4TL设置报警时间和短路电流倍数",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },
    // WYA1-4TL 设置报警状态投入或关闭
    wya1SetAlarmState:{
        url: `${config.API_WYA1_COMMAND}/order/900E`,
        name: "WYA1-4TL设置报警状态投入或关闭",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    // 天一达 下发指令
    tianyidaCommand:{
        url: `${config.API_TIANYIDA}/sendCommand/`,
        name: "天一达 下发指令",
        post: async function (command,data) {
            return await http.post(this.url + command,data);
        }
    },

    // 获取天一达运行日志
    getTianyidaDataRunlog:{
        url: `${config.API_URL}/tianYiDa/query/resultlog/`,
        name: "获取天一达运行日志",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },

    positioning_upload_cycle: {
        url: `${config.API_GAS}/order/issuePositioningUploadCycle`,
        name: "设置GPS上传周期",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    industry4g_history_data:{
        url: `${config.API_URL}/industry4g/historicalData/`,
        name: "获取4G工业历史数据",
        get: async function (id,data) {
            return await http.get(this.url + id + '/',data);
        }
    },

    gethumitureSetting:{
        url: `${config.API_URL}/humitureAlarm/order/value/`,
        name: "获取4G工业历史数据",
        get: async function (id,data) {
            return await http.get(this.url + id ,data);
        }
    },

    queryJKD30456Detail: {
        url: `${config.API_URL}/JKD-304-4G-02/detailed/`,
        name: "查询JKD-304-4G-02设备详细数据",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },

    queryJKD30456Phone: {
        url: `${config.API_URL}/JKD-304-4G-02/phone/`,
        name: "查询JKD-304-4G-02号码数据",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },

    queryJKD30456Coordinate: {
        url: `${config.API_URL}/JKD-304-4G-02/coordinate/`,
        name: "查询JKD-304-4G-02经纬度数据",
        get: async function (deviceNumber) {
            return await http.get(this.url + deviceNumber);
        }
    },

    queryJKD30456CoordinateHistory: {
        url: `${config.API_URL}/JKD-304-4G-02/coordinate/`,
        name: "查询JKD-304-4G-02经纬度历史数据",
        get: async function (coordinateType, deviceNumber, data) {
            return await http.get(this.url + coordinateType + '/' + deviceNumber, data);
        }
    },

    setJKD30456Phone: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/0D`,
        name: "设置JKD-304-4G-02号码",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    setJKD30456Volume: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/0V`,
        name: "设置JKD-304-4G-02音量大小",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    setJKD30456SilentMode: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/12`,
        name: "设置JKD-304-4G-02静音模式",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    setJKD30456LocatePriority: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/14`,
        name: "设置JKD-304-4G-02定位优先级",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    setJKD30456PositioningSwitch: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/17`,
        name: "设置JKD-304-4G-02定位开关",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    setJKD30456WhiteListModel: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/19`,
        name: "设置JKD-304-4G-02白名单模式",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    setJKD30456VoiceMode: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/1A`,
        name: "设置JKD-304-4G-02语音模式",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    otaUpgradeJKD30456: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/15`,
        name: "JKD-304-4G-02 OTA升级",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    resetJKD30456: {
        url: `${config.API_URL}/JKD-304-4G-02/set/order/1E`,
        name: "JKD-304-4G-02恢复出厂设置",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    // 查询JY-RB002-4G-02-YB2多阀门信息
    getJYRB002ValveInfo: {
        url: `${config.API_URL}/JY-RB002-4G-02-YB2/query/valve/`,
        name: "查询JY-RB002-4G-02-YB2阀门信息",
        get: async function (id) {
            return await http.get(this.url + id);
        }
    },

    // 删除JY-RB002-4G-02-YB2阀门
    deleteJYRB002Valve: {
        url: `${config.API_URL}/JY-RB002-4G-02-YB2/delete/valve`,
        name: "删除JY-RB002-4G-02-YB2阀门",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    // 查询排风扇状态（JKD-852-FAN）
    getExhaustFanStatus: {
        url: `${config.API_URL}/homeAlarm4g/exhaustFan/`,
        name: "查询排风扇状态",
        get: async function (deviceId) {
            return await http.get(this.url + deviceId);
        }
    },

    mqttSetUploadCycle: {
        url: `${config["4G_GAS_MQTT"]}/command/set/uploadCycle`,
        name: "MQTT下发上传周期",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    mqttSetSamplingCycle: {
        url: `${config["4G_GAS_MQTT"]}/command/set/samplingCycle`,
        name: "MQTT下发采样周期",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    mqttSetPositioningCycle: {
        url: `${config["4G_GAS_MQTT"]}/command/set/positioningCycle`,
        name: "MQTT下发定位周期",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    mqttSetAlarmSilenceTime: {
        url: `${config["4G_GAS_MQTT"]}/command/set/alarmSilenceTime`,
        name: "MQTT下发报警静默时间",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    mqttSetVibrationSensitivity: {
        url: `${config["4G_GAS_MQTT"]}/command/set/vibrationSensitivity`,
        name: "MQTT下发震动灵敏度等级",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    mqttSetMovementSensitivity: {
        url: `${config["4G_GAS_MQTT"]}/command/set/movementSensitivity`,
        name: "MQTT下发移动灵敏度等级",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    mqttSetAlarmThreshold: {
        url: `${config["4G_GAS_MQTT"]}/command/set/alarmThreshold`,
        name: "MQTT下发报警阈值",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    mqttSetControllerOutput: {
        url: `${config["4G_GAS_MQTT"]}/command/set/controllerOutput`,
        name: "MQTT下发控制器输出",
        post: async function (data) {
            return await http.post(this.url, data);
        }
    },

    r60bQlyAttribute: {
        url: `${config.API_URL}/device/R60B_QLY/sleepRadar/attribute/`,
        name: "R60B-QLY查询实时属性",
        get: async function (masterId) {
            return await http.get(this.url + masterId);
        },
    },
    r60bQlyFunc: {
        url: `${config.API_URL}/device/R60B_QLY/sleepRadar/func/`,
        name: "R60B-QLY查询功能配置",
        get: async function (masterId) {
            return await http.get(this.url + masterId);
        },
    },
    r60bQlyEvent: {
        url: `${config.API_URL}/device/R60B_QLY/sleepRadar/event/`,
        name: "R60B-QLY查询事件统计",
        get: async function (masterId) {
            return await http.get(this.url + masterId);
        },
    },

};
